module.exports = __webpack_public_path__ + "media/images/btn_see_stallion_fees-0747af38bd8e142bd0eeb95afdacc9b5.gif";